import { Grid } from '@material-ui/core';
import React, { VFC } from 'react';

import { setParamsToUrlWithReplace } from 'utils/urlUtils';

import { SelectedSortBy, Sort } from './Sort';
import { SelectedStatus, StatusFilter } from './StatusFilter';
import { useStyles } from './styles';

export interface SelectedFilters {
  status: SelectedStatus;
  models: Array<string>;
  intents: Array<string>;
  sortBy: SelectedSortBy;
}

export interface FiltersProps {
  selectedFilters: SelectedFilters;
  setSelectedFilters: React.Dispatch<React.SetStateAction<SelectedFilters>>;
  setShowLoadMore: (flag: boolean) => void;
}

export const Filters: VFC<FiltersProps> = ({
  selectedFilters,
  setSelectedFilters,
  setShowLoadMore,
}) => {
  const styles = useStyles();

  const handleStatusChange = (status: SelectedStatus) => {
    setSelectedFilters({ ...selectedFilters, status });
    setParamsToUrlWithReplace({ status });
    setShowLoadMore(false);
  };

  const handleSortChange = (sortBy: SelectedSortBy) => {
    setSelectedFilters({ ...selectedFilters, sortBy });
    setParamsToUrlWithReplace({ sortBy });
    setShowLoadMore(false);
  };

  return (
    <Grid direction="row" className={styles.filterContainer}>
      <Sort
        selectedSortBy={selectedFilters.sortBy}
        handleSortChange={handleSortChange}
      />
      <StatusFilter
        selectedStatus={selectedFilters.status}
        handleStatusChange={handleStatusChange}
      />
    </Grid>
  );
};
